import { render, staticRenderFns } from "./current-order-list.vue?vue&type=template&id=e5ec2588&"
import script from "./current-order-list.vue?vue&type=script&lang=js&"
export * from "./current-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports